import { User } from '@vsolv/core/users/domain';
import { OwnerType } from './owner-type';
import { Status } from './status';
import { Type } from './type';

export const HOLD_TEXT_MAX_LENGTH = 1000;
export const HOLD_EVIDENCE_MAX_FILES = 20;

/** A claim attachment linked to the hold, while open or on completion. */
export interface EvidenceFile {
  storageItemId: string;
  /** The file's current title, even after it's removed. */
  title: string;
  /** The file was deleted from the claim after it was linked. */
  removed: boolean;
  created: Date;
  createdById: string | null;
}

/** Evidence a job needs before it can be approved. Opening one doesn't change the job's status. */
export interface Model {
  id: string;

  claimId: string;
  claimItemId: string;

  /** The charge the hold is about, or null when it's about the whole job. */
  claimItemLineId: string | null;

  type: Type;

  requestedEvidence: string;

  ownerType: OwnerType;
  /** Staff user id or service provider id, depending on the owner type. */
  ownerId: string;
  /** The owner's name when the hold was opened. */
  ownerName: string;

  dueDate: Date;

  status: Status;

  completedById: string | null;
  completedBy?: User.Model | null;
  completedAt: Date | null;
  completionNote: string | null;
  /** Linked files. Only set when listing holds; empty without attachment access. */
  evidence?: EvidenceFile[];

  cancelledById: string | null;
  cancelledAt: Date | null;
  cancelReason: string | null;

  created: Date;
  createdById: string | null;
  createdBy?: User.Model | null;
}

export interface OpenHoldRequest {
  claimItemLineId?: string | null;
  type: Type;
  requestedEvidence: string;
  ownerType: OwnerType;
  ownerId: string;
  dueDate: Date;
}

export interface CompleteHoldRequest {
  note?: string | null;
  /** Claim attachments (storage item ids) that satisfied the hold. */
  documentIds?: string[];
}

export interface AttachEvidenceRequest {
  /** Claim attachments (storage item ids) to link; ones already linked are skipped. */
  documentIds: string[];
}

export interface CancelHoldRequest {
  reason: string;
}

export interface HoldResponse {
  id: string;
}

export interface ListHoldsResponse {
  items: Model[];
}
